import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IdDdWaiverFunctionalBhAss = ({
   itemsRef,
   showErrorFor,

}) => {

   return (
      <form id='LHH_IdDdWaiverFunctionalBhAss' className='file-pdf-document'>
         <div className='file-template'>

            <h3>ID/DD Waiver Functional Behavior Assessment</h3>

            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Respondents(s):</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Behavior Consultant/Credentials/Agency:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='text' id='txtRespondents' name='txtRespondents' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type='text' id='txtBehavior4' name='txtBehavior4' className='add-only' />
                  </td>
               </tr>
            </table>

            <h3>I. Description of Behavior(s)</h3>

            <p>
               <span className='eleHeader'>A. What are the behavior(s) of concern?</span>
               <span className='small'>
                  For each, define the topograpy (how it is performed),
                  frequency (how often it occurs per day, week, or mounth), duration
                  (how long it lasts when it occurs), and intensity (the magnitude of the behavior - low, medium,
                  high - and if it causes harm).
               </span>
               <textarea id='txtDescription' name='txtDescription' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>Behavior and Topography</span>
               <textarea id='txtBehaviorTopography' name='txtBehaviorTopography' className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity</span></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorFrequency' name='txtBehaviorFrequency' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorDuration' name='txtBehaviorDuration' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorIntensity' name='txtBehaviorDuration' className='add-only' />
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'>Behavior and Topography</span>
               <textarea id='txtBehaviorTopography1' name='txtBehaviorTopography1' className='add-only'></textarea>
            </p>

            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity</span></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorFrequency1' name='txtBehaviorFrequency1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorDuration1' name='txtBehaviorDuration1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorIntensity1' name='txtBehaviorDuration1' className='add-only' />
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'>Behavior and Topography</span>
               <textarea id='txtBehaviorTopography2' name='txtBehaviorTopography2' className='add-only'></textarea>
            </p>

            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity</span></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorFrequency2' name='txtBehaviorFrequency2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorDuration2' name='txtBehaviorDuration2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorIntensity2' name='txtBehaviorDuration2' className='add-only' />
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'>Behavior and Topography</span>
               <textarea id='txtBehaviorTopography3' name='txtBehaviorTopography3' className='add-only'></textarea>
            </p>

            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Frequency</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Duration</span></td>
                  <td className='w-250'>
                     <span className='eleHeader'>Intensity</span></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorFrequency3' name='txtBehaviorFrequency3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorDuration3' name='txtBehaviorDuration3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorIntensity3' name='txtBehaviorDuration3' className='add-only' />
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'>B. Which of the behaviors described above occur together </span><span className='small'>(e.g., occur at the same time; occur in a
                  redictable chain; occur in res onse to the same situation)?</span>
               <textarea id='txtDescription1' name='txtDescription1' className='add-only'></textarea>
            </p>

            <h3>II. Ecological Events That May Affect the Behavior(s)</h3>

            <p>
               <span className='eleHeader'>A. What medicationsis the persontaking(if any), and howdo you believethese may affecthis/her
                  behaviors?</span>
               <textarea id='txtEcological' name='txtEcological' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>B. What medicalcomplications(if any) does the personexperiencethat may affect his/herbehavior
               </span><span className='small'>(e.g., asthma, aller ies, rashes, sinus infections, seizures, etc.)?</span>
               <textarea id='txtEcological1' name='txtEcological1' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>C. Describe the sleep cycles of the person and the extent to which these cycles affect his/her behavior.</span>
               <textarea id='txtEcological2' name='txtEcological2' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>D. Describe the eating routines and diet of the person and the extent to which these routines may affect his/her behavior.</span>
               <textarea id='txtEcological3' name='txtEcological3' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>E. Briefly list below the person's typical daily schedule of activities:</span>
            </p>

            <table>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>6:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule' name='txtSchedule' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>3:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule' name='txtDSchedule' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>7:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule1' name='txtSchedule1' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>4:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule1' name='txtDSchedule1' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>8:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule2' name='txtSchedule2' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>5:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule2' name='txtDSchedule2' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>9:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule3' name='txtSchedule3' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>6:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule3' name='txtDSchedule3' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>10:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule4' name='txtSchedule4' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>7:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule4' name='txtDSchedule4' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>11:00 am</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule5' name='txtSchedule5' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>8:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule5' name='txtDSchedule5' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>12:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule6' name='txtSchedule6' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>9:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule6' name='txtDSchedule6' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>1:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule7' name='txtSchedule7' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>10:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule7' name='txtDSchedule7' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-187'>
                     <span className='eleHeader'>2:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtSchedule8' name='txtSchedule8' className='add-only' />
                  </td>
                  <td className='w-187'>
                     <span className='eleHeader'>11:00 pm</span>
                  </td>
                  <td className='w-187'>
                     <input type='text' id='txtDSchedule8' name='txtDSchedule8' className='add-only' />
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'>F. Describe the extent to which you believe the activities that occur during the day are predictable
                  for the person. </span><span className='small'>(e.g., when to get up, eat dinner,shower, goto school/work,etc.)?</span>
               <textarea id='txtDescribe1' name='txtDescribe1' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>G. About how often does the person get to make choices about activities, reinforcers, etc.? In what
                  areas does the person get to make choices </span><span className='small'>(e.g., food, clothing, social companions, leisure activities, etc.)?</span>
               <textarea id='txtDescribe2' name='txtDescribe2' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>H. Describe the variety of activities performed on a typical day </span><span className='small'>(exercise, community activityes, etc.)</span>
               <textarea id='txtDescribe3' name='txtDescribe3' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>I. How many other people are in the setting (work/school/home)? Do you believe that the density of people or
                  interactions with other persons affect the targeted behaviors?</span>
               <textarea id='txtDescribe4' name='txtDescribe4' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>J. If the person is attending a day program, what is the staffing pattern? To what extent do you
                  believe the number of staff, training of staff, quality of socila contacts with staff, etc., affect the
                  targeted behaviors?</span>
               <textarea id='txtDescribe5' name='txtDescribe5' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>K. If not attending a day program, describe some typical interactions of the person with others in
                  the home or other environments.</span>
               <textarea id='txtDescribe6' name='txtDescribe6' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>L. Are the tasks/activities presented during the day boring or unpleasant for the person, or do they lead to results that are preferred or valued?</span>
               <textarea id='txtDescribe7' name='txtDescribe7' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>M. If the person attends a day program, what outcomes are monitored regularly by staff (frequency of behaviors, skills learned, activity patterns)?</span>
               <textarea id='txtDescribe8' name='txtDescribe8' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>N. if the person does not attend a day program, how do people in the home or other environments monitor outcomes?</span>
               <textarea id='txtDescribe9' name='txtDescribe9' className='add-only'></textarea>
            </p>

            <h3>Ill. Events and Situations that Predict Occurrences of the Behavior(s)</h3>

            <p>
               <span className='eleHeader'>A. Timeof Day: When is the behavior(s)most likely and least likely to occur?</span>
               <input type='radio' id='rbActive_Yes' name='rbActive' className='add-only' value='1' /> Most Likely &nbsp;
               <input type='radio' id='rbActive_No' name='rbActive' className='add-only' value='0' /> Least Likely
            </p>
            <p>
               <span className='eleHeader'>B. Setting: Where is the behavior most likely and least likely to occur?</span>
               <input type='radio' id='rbActive1_Yes' name='rbActive1' className='add-only' value='1' /> Most Likely &nbsp;
               <input type='radio' id='rbActive1_No' name='rbActive1' className='add-only' value='0' /> Least Likely
            </p>
            <p>
               <span className='eleHeader'>C. Control: With whom is the behavior most likely and least likely to occur?</span>
               <input type='radio' id='rbActive2_Yes' name='rbActive2' className='add-only' value='1' /> Most Likely &nbsp;
               <input type='radio' id='rbActive2_No' name='rbActive2' className='add-only' value='0' /> Least Likely
            </p>
            <p>
               <span className='eleHeader'>D. What activity is mostl ikely and least likely to produce the behavior(s)?</span>
               <input type='radio' id='rbActive3_Yes' name='rbActive3' className='add-only' value='1' /> Most Likely &nbsp;
               <input type='radio' id='rbActive3_No' name='rbActive3' className='add-only' value='0' /> Least Likely
            </p>
            <p>
               <span className='eleHeader'>E. Are there particular situations, events, etc., that are not listed previously that 'set off' the behavior(s)
                  that cause concern </span><span className='small'>(particular demands, interruptions, transitions, delays, being ignored, etc.)?</span>
               <textarea id='txtSituations' name='txtSituations' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>F. What would be the one thing you could do that would be most likely to make the undesirable behavior(s) occur?</span>
               <textarea id='txtSituations1' name='txtSituations1' className='add-only'></textarea>
            </p>

            <h3>IV. Function of the Undesirable Behavior(s)</h3>

            <p>
               <span className='eleHeader'>A. Review each of the behavior lsisted in Part I and define the function(s) you believe the behavior
                  serves for the Person (i.e., what does he/she get and/or avoid by doing the behavior?)</span>
            </p>
            <table>
               <tr>
                  <td className='w-375'><b>Behavior:</b></td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she get?</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she avoid?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior_Yes' name='rbBehavior' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior_No' name='rbBehavior' className='add-only' value='0' /> No
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior7_Yes' name='rbBehavior7' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior7_No' name='rbBehavior7' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'><b>Behavior:</b></td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she get?</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she avoid?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior1_Yes' name='rbBehavior1' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior1_No' name='rbBehavior1' className='add-only' value='0' /> No
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior2_Yes' name='rbBehavior2' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior2_No' name='rbBehavior2' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'><b>Behavior:</b></td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she get?</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she avoid?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior3_Yes' name='rbBehavior3' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior3_No' name='rbBehavior3' className='add-only' value='0' /> No
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior4_Yes' name='rbBehavior4' className='add-only' value='1' /> Yes &nbsp;
                     <input type='radio' id='rbBehavior4_No' name='rbBehavior4' className='add-only' value='0' /> No
                  </td>
               </tr>
               <tr>
                  <td className='w-375'><b>Behavior:</b></td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she get?</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>What does he/she avoid?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior5_Yes' name='rbBehavior5' className='add-only' value='1' /> Yes &nbsp; 
                     <input type='radio' id='rbBehavior5_No' name='rbBehavior5' className='add-only' value='0' /> No
                  </td>
                  <td className='w-375'>
                     <input type='radio' id='rbBehavior6_Yes' name='rbBehavior6' className='add-only' value='1' /> Yes &nbsp; 
                     <input type='radio' id='rbBehavior6_No' name='rbBehavior6' className='add-only' value='0' /> No
                  </td>
               </tr>
            </table>

            <p>
               <span className='eleHeader'> B. Describe the person's most typical response to the following situations:</span>
            </p>

            <p>
               1. Is the above behavior(s) more likely <input type='radio' id='rbDescribe51_Yes' name='rbDescribe51' className='add-only' value='1' /> &nbsp; 
               less likely &nbsp; <input type='radio' id='rbDescribe51_No' name='rbDescribe51' className='add-only' value='2' /> &nbsp; 
               unaffected &nbsp; <input type='radio' id='rbDescribe51_Na' name='rbDescribe51' className='add-only' value='3' /> if you present him/her with a difficult task?
            </p>
            <p>
               2. Is the above behavior(s) more likely <input type='radio' id='rbDescribe1_Yes' name='rbDescribe1' className='add-only' value='1' /> &nbsp; 
               less likely &nbsp; <input type='radio' id='rbDescribe1_No' name='rbDescribe1' className='add-only' value='2' /> &nbsp; 
               unaffected &nbsp; <input type='radio' id='rbDescribe1_Na' name='rbDescribe1' className='add-only' value='3' /> if you interrupt a desired event (eating ice cream, watching TV, etc.)?
            </p>
            <p>
               3. Is the above behavior(s) more likely <input type='radio' id='rbDescribe2_Yes' name='rbDescribe2' className='add-only' value='1' /> &nbsp; 
               less likely &nbsp; <input type='radio' id='rbDescribe2_No' name='rbDescribe2' className='add-only' value='2' /> &nbsp; 
               unaffected &nbsp; <input type='radio' id='rbDescribe2_Na' name='rbDescribe2' className='add-only' value='3' /> if you deliver a 'stern' request/command/reprimand?
            </p>
            <p>
               4. Is the above behavior(s) more likely <input type='radio' id='rbDescribe_Yes' name='rbDescribe3' className='add-only' value='1' /> &nbsp; 
               less likely &nbsp; <input type='radio' id='rbDescribe3_No' name='rbDescribe3' className='add-only' value='2' /> &nbsp; 
               unaffected &nbsp; <input type='radio' id='rbDescribe3_Na' name='rbDescribe3' className='add-only' value='3' /> if you are present but do not interact with him/her?
            </p>
            <p>
               5. Is the above behavior(s) more likely <input type='radio' id='rbDescribe4_Yes' name='rbDescribe4' className='add-only' value='1' /> &nbsp; 
               less likely &nbsp; <input type='radio' id='rbDescribe4_No' name='rbDescribe4' className='add-only' value='2' /> &nbsp; 
               unaffected &nbsp; <input type='radio' id='rbDescribe4_Na' name='rbDescribe4' className='add-only' value='3' /> if the routine is changed?
            </p>
            <p>
               6. Is the above behavior(s) more likely <input type='radio' id='rbDescribe5_Yes' name='rbDescribe5' className='add-only' value='1' /> &nbsp;
               less likely &nbsp; <input type='radio' id='rbDescribe5_No' name='rbDescribe5' className='add-only' value='2' /> &nbsp;
               unaffected  &nbsp; <input type='radio' id='rbDescribe5_Na' name='rbDescribe5' className='add-only' value='3' /> if something the person wants is present but he/she cannot get to it(i.e., a desired object that
               is out of reach)?
            </p>
            <p>
               7. Is the above behavior(s) more likely <input type='radio' id='rbDescribe65_Yes' name='rbDescribe65' className='add-only' value='1' /> &nbsp;
               less likely &nbsp;<input type='radio' id='rbDescribe65_No' name='rbDescribe65' className='add-only' value='2' /> &nbsp;
               unaffected <input type='radio' id='rbDescribe65_Na' name='rbDescribe65' className='add-only' value='3' /> if he/she is alone?
            </p>

            <h3>V. Efficiency of the Undesirable Behavior(s)</h3>

            <p>
               <span className='eleHeader'>A. What amount of physical effort is involved in the behavior(s) (e.g., prolonged intense tantrums - vs-simple verbal optbursts, etc.)?</span>
               <textarea id='txtPhysical' name='txtPhysical' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>B. Does engaging in the behavior(s) result in a 'payoff' (getting attention, avoiding work) every time? Almost every time? Once in a while?</span>
               <textarea id='txtPhysical1' name='txtPhysical1' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>C. How much of a delay is ther between the time the person engages in the behavior(s) and gets the 'payoff'? Is it immediate, a few seconds, or longer?</span>
               <textarea id='txtPhysical2' name='txtPhysical2' className='add-only'></textarea>
            </p>

            <h3>VI. Primary Method(s) Used by the Person to Communicate</h3>

            <table>
               <tr>
                  <td className='w-750'><b>A. What are the general expressive communication strategies used by or available to the person in the following situations?</b></td>
               </tr>
               <tr>
                  <td className='w-120'>&nbsp;</td>
                  <td className='w-90'><span className='eleHeader'>Request attention</span></td>
                  <td className='w-90'><span className='eleHeader'>Request Help</span></td>
                  <td className='w-90'><span className='eleHeader'>Request preferred food/ objects/ activities</span></td>
                  <td className='w-90'><span className='eleHeader'>Show you something or a place</span></td>
                  <td className='w-90'><span className='eleHeader'>Indicate physical pain</span></td>
                  <td className='w-90'><span className='eleHeader'>Indicate confusion</span></td>
                  <td className='w-90'><span className='eleHeader'>Protest/ reject situation</span></td>
               </tr>
               <tr>
                  <td className='w-120'>Complex speech</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest' name='txtRelationshipRequest' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp' name='txtRelationshipHelp' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood' name='txtRelationshipFood' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow' name='txtRelationshipShow' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate' name='txtRelationshipIndicate' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion' name='txtRelationshipConfusion' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest' name='txtRelationshipProtest' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Multiple words</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest1' name='txtRelationshipRequest1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp1' name='txtRelationshipHelp1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood1' name='txtRelationshipFood1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow1' name='txtRelationshipShow1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate1' name='txtRelationshipIndicate1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion1' name='txtRelationshipConfusion1' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest1' name='txtRelationshipProtest1' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>One word utterances</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest2' name='txtRelationshipRequest2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp2' name='txtRelationshipHelp2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood2' name='txtRelationshipFood2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow2' name='txtRelationshipShow2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate2' name='txtRelationshipIndicate2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion2' name='txtRelationshipConfusion2' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest2' name='txtRelationshipProtest2' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Complex signing</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest3' name='txtRelationshipRequest3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp3' name='txtRelationshipHelp3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood3' name='txtRelationshipFood3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow3' name='txtRelationshipShow3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate3' name='txtRelationshipIndicate3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion3' name='txtRelationshipConfusion3' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest3' name='txtRelationshipProtest3' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Simple signs</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest4' name='txtRelationshipRequest4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp4' name='txtRelationshipHelp4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood4' name='txtRelationshipFood4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow4' name='txtRelationshipShow4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate4' name='txtRelationshipIndicate4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion4' name='txtRelationshipConfusion4' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest4' name='txtRelationshipProtest4' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Echolalia</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest5' name='txtRelationshipRequest5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp5' name='txtRelationshipHelp5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood5' name='txtRelationshipFood5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow5' name='txtRelationshipShow5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate5' name='txtRelationshipIndicate5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion5' name='txtRelationshipConfusion5' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest5' name='txtRelationshipProtest5' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Pointing</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest6' name='txtRelationshipRequest6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp6' name='txtRelationshipHelp6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood6' name='txtRelationshipFood6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow6' name='txtRelationshipShow6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate6' name='txtRelationshipIndicate6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion6' name='txtRelationshipConfusion6' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest6' name='txtRelationshipProtest6' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Leading</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest7' name='txtRelationshipRequest7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp7' name='txtRelationshipHelp7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood7' name='txtRelationshipFood7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow7' name='txtRelationshipShow7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate7' name='txtRelationshipIndicate7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion7' name='txtRelationshipConfusion7' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest7' name='txtRelationshipProtest7' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Grab/Reach</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest8' name='txtRelationshipRequest8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp8' name='txtRelationshipHelp8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood8' name='txtRelationshipFood8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow8' name='txtRelationshipShow8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate8' name='txtRelationshipIndicate8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion8' name='txtRelationshipConfusion8' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest8' name='txtRelationshipProtest8' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Increased movement</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest9' name='txtRelationshipRequest9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp9' name='txtRelationshipHelp9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood9' name='txtRelationshipFood9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow9' name='txtRelationshipShow9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate9' name='txtRelationshipIndicate9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion9' name='txtRelationshipConfusion9' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest9' name='txtRelationshipProtest9' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Moves away</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest10' name='txtRelationshipRequest10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp10' name='txtRelationshipHelp10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood10' name='txtRelationshipFood10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow10' name='txtRelationshipShow10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate10' name='txtRelationshipIndicate10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion10' name='txtRelationshipConfusion10' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest10' name='txtRelationshipProtest10' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Moves closer</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest11' name='txtRelationshipRequest11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp11' name='txtRelationshipHelp11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood11' name='txtRelationshipFood11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow11' name='txtRelationshipShow11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate11' name='txtRelationshipIndicate11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion11' name='txtRelationshipConfusion11' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest11' name='txtRelationshipProtest11' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Fixed gaze</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest12' name='txtRelationshipRequest12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp12' name='txtRelationshipHelp12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood12' name='txtRelationshipFood12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow12' name='txtRelationshipShow12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate12' name='txtRelationshipIndicate12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion12' name='txtRelationshipConfusion12' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest12' name='txtRelationshipProtest12' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Facial expressions</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest13' name='txtRelationshipRequest13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp13' name='txtRelationshipHelp13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood13' name='txtRelationshipFood13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow13' name='txtRelationshipShow13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate13' name='txtRelationshipIndicate13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion13' name='txtRelationshipConfusion13' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest13' name='txtRelationshipProtest13' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Aggression</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest14' name='txtRelationshipRequest14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp14' name='txtRelationshipHelp14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood14' name='txtRelationshipFood14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow14' name='txtRelationshipShow14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate14' name='txtRelationshipIndicate14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion14' name='txtRelationshipConfusion14' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest14' name='txtRelationshipProtest14' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Self-injury</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest15' name='txtRelationshipRequest15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp15' name='txtRelationshipHelp15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood15' name='txtRelationshipFood15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow15' name='txtRelationshipShow15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate15' name='txtRelationshipIndicate15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion15' name='txtRelationshipConfusion15' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest15' name='txtRelationshipProtest15' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Eye movements</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest16' name='txtRelationshipRequest16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp16' name='txtRelationshipHelp16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood16' name='txtRelationshipFood16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow16' name='txtRelationshipShow16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate16' name='txtRelationshipIndicate16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion16' name='txtRelationshipConfusion16' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest16' name='txtRelationshipProtest16' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-120'>Augmentative communication</td>
                  <td className='w-90'><input type='text' id='txtRelationshipRequest17' name='txtRelationshipRequest17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipHelp17' name='txtRelationshipHelp17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipFood17' name='txtRelationshipFood17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipShow17' name='txtRelationshipShow17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipIndicate17' name='txtRelationshipIndicate17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipConfusion17' name='txtRelationshipConfusion17' className='add-only' /></td>
                  <td className='w-90'><input type='text' id='txtRelationshipProtest17' name='txtRelationshipProtest17' className='add-only' /></td>
               </tr>
            </table>

            <p>
               <b> B. With regard to receptive communication:</b>
            </p>
            <p>
               <span className='eleHeader'>1. Does the person follow requests or insturctions? </span>
               <input type='radio' id='rbFamily_Yes' name='rbFamily' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbFamily_No' name='rbFamily' className='add-only' value='0' /> No
            </p>

            <p>If so approximately how many?
               <textarea id='txtFamily' name='txtFamily' className='add-only'></textarea>
            </p>

            <p>
               <span className='eleHeader'>2. Is the person able to imitate physical models for various tasks or activities?</span>
               <input type='radio' id='rbFamily1_Yes' name='rbFamily1' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbFamily1_No' name='rbFamily1' className='add-only' value='0' /> No
            </p>
            <p>
               <span className='eleHeader'>3. Does the person respond to signed or gestural requests or insturctions?</span>
               <input type='radio' id='rbFamily2_Yes' name='rbFamily2' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbFamily2_No' name='rbFamily2' className='add-only' value='0' /> No
            </p>
            <p>
               <span className='eleHeader'>4. How does the person indicate yes or no?</span>
               <textarea id='txtFamily4' name='txtFamily4' className='add-only'></textarea>
            </p>
            <h3>VII. Events, Actions, and Objects Perceived as Positive by the Person?</h3>
            <p>
               <span className='eleHeader'>A. In general, what are the things (events/activities/objects/people) that appear to be reinforcing or enjoyable for the person?</span>
               <textarea id='txtFamily41' name='txtFamily41' className='add-only'></textarea>
            </p>

            <h3>VIII. 'Functional Alternative' Behaviors Known by the Person?</h3>

            <p>
               <span className='eleHeader'>A. What socially appropriate behaviors/skills does the person perform that may be ways of achieving the same function(s) as the behavior(s) of concern?</span>
               <textarea id='txtFunctional' name='txtFunctional' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>B. What things can you do to improve the likelihood that a teaching session will occur smoothly?</span>
               <textarea id='txtFunctional1' name='txtFunctional1' className='add-only'></textarea>
            </p>
            <p>
               <span className='eleHeader'>C. What things can you do that would interfere with or disrupt a teaching session?</span>
               <textarea id='txtFunctional2' name='txtFunctional2' className='add-only'></textarea>
            </p>

            <h3>IX. History of the Undesirable Behavior(s) and Programs that Have Been Attempted</h3>

            <table>
               <tr>
                  <td className='w-50'>&nbsp;</td>
                  <td className='w-150'><span className='eleHeader'>Behavior</span></td>
                  <td className='w-150'><span className='eleHeader'>How long has this been a problem?</span></td>
                  <td className='w-250'><span className='eleHeader'>Programs</span></td>
                  <td className='w-150'><span className='eleHeader'>Effect</span></td>
               </tr>
               <tr>
                  <td className='w-50'>1.</td>
                  <td className='w-150'><input type='text' id='txtBehavior11' name='txtBehavior11' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtProblem' name='txtProblem' className='add-only' /></td>
                  <td className='w-250'><input type='text' id='txtRelationshipPrograms' name='txtRelationshipPrograms' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtEffect' name='txtEffect' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-50'>2.</td>
                  <td className='w-150'><input type='text' id='txtBehavior1' name='txtBehavior1' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtProblem1' name='txtProblem1' className='add-only' /></td>
                  <td className='w-250'><input type='text' id='txtRelationshipPrograms1' name='txtRelationshipPrograms1' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtEffect1' name='txtEffect1' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-50'>3.</td>
                  <td className='w-150'><input type='text' id='txtBehavior2' name='txtBehavior2' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtProblem2' name='txtProblem2' className='add-only' /></td>
                  <td className='w-250'><input type='text' id='txtRelationshipPrograms2' name='txtRelationshipPrograms2' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtEffect2' name='txtEffect2' className='add-only' /></td>
               </tr>
               <tr>
                  <td className='w-50'>4.</td>
                  <td className='w-150'><input type='text' id='txtBehavior3' name='txtBehavior3' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtProblem3' name='txtProblem3' className='add-only' /></td>
                  <td className='w-250'><input type='text' id='txtRelationshipPrograms3' name='txtRelationshipPrograms3' className='add-only' /></td>
                  <td className='w-150'><input type='text' id='txtEffect3' name='txtEffect3' className='add-only' /></td>
               </tr>
            </table>

            <h3>Summary/Recommendations</h3>

            <table>
               <tr>
                  <td className='w-750'><b>Based on the Functional Behavior Assessment, the followin action s /behavior s were discovered:</b></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Behavior</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Function</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Location</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalBehavior' name='txtFunctionalBehavior' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalFunction' name='txtFunctionalFunction' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalLocation' name='txtFunctionalLocation' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalBehavior1' name='txtFunctionalBehavior1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalFunction1' name='txtFunctionalFunction1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalLocation1' name='txtFunctionalLocation1' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalBehavior2' name='txtFunctionalBehavior2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalFunction2' name='txtFunctionalFunction2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalLocation2' name='txtFunctionalLocation2' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalBehavior3' name='txtFunctionalBehavior3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalFunction3' name='txtFunctionalFunction3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtFunctionalLocation3' name='txtFunctionalLocation3' className='add-only' />
                  </td>
               </tr>
            </table>
            <p>
               <span className='eleHeader'>The results of the assessment(s) reflect that the action(s)/behavior(s)
                  demonstrated by the person pose a risk to the health and welfare of the person and/or others.</span>
               <input type='radio' id='rbResults_Yes' name='rbResults' className='add-only' value='1' /> Yes &nbsp;
               <input type='radio' id='rbResults_No' name='rbResults' className='add-only' value='0' /> No
            </p>
            <table>
               <tr>
                  <td className='w-750'><b>If a risk(s) exist, list them below:</b></td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Behavior</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Risk to Self</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Risk to Others</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorList' name='txtBehaviorList' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRisk' name='txtRisk' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRiskOther' name='txtRiskOther' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorList1' name='txtBehaviorList1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRisk1' name='txtRisk1' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRiskOther1' name='txtRiskOther1' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorList2' name='txtBehaviorList2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRisk2' name='txtRisk2' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRiskOther2' name='txtRiskOther2' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type='text' id='txtBehaviorList3' name='txtBehaviorList3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRisk3' name='txtRisk3' className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='text' id='txtRiskOther3' name='txtRiskOther3' className='add-only' />
                  </td>
               </tr>
            </table>
            <p>
               <span className='eleHeader'>Recommendations:</span>
               <textarea id='txtRecommendations' name='txtRecommendations' className='add-only'></textarea>
            </p>


         </div>
      </form >

   )
}











